
import {defineComponent} from 'vue'
import BaseTitle from "@/components/UI/BaseTitle.vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import InputFile from "@/components/UI/InputFile.vue";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";
import {
  PrepareCsvHandlingRequestRestDtoModel
} from "@/models/api/pharma-cpc-import/PrepareCsvHandlingRequestRestDtoModel";
import {ImportRestService} from "@/services/rest/cpc-import/ImportRestService";
import {
  PrepareXlsxHandlingRequestRestDtoModel
} from "@/models/api/pharma-cpc-import/PrepareXlsxHandlingRequestRestDtoModel";
import {
  AsyncHandlingResponseRestDto,
  HandleCsvRequestRestDto,
  HandleXlsxRequestRestDto,
  MappedColumnRestDto,
  PrepareImportHandlingResponseRestDto
} from "@/api/pharma-cpc-import/models";
import InputSelect from "@/components/UI/InputSelect.vue";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import {FormMixin} from "@/components/base/FormMixin";

export default defineComponent({
  name: "ImportProducts",
  mixins: [FormMixin],
  components: {
    GenericFormWrapper,
    InputSelect,
    InputCheckboxBoolean,
    InputFile,
    BaseContainer,
    BaseTitle,
  },
  props: {
    showBackRoute: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      step: 'selection' as 'selection' | 'mapping',
      selectedFileType: '' as '' | 'csv' | 'xlsx',
      prepareCsvHandlingRequest: PrepareCsvHandlingRequestRestDtoModel.createWithDefaults(),
      prepareXlsxHandlingRequest: PrepareXlsxHandlingRequestRestDtoModel.createWithDefaults(),
      prepareImportHandlingResponse: null as PrepareImportHandlingResponseRestDto | null,
      handlingResponse: null as AsyncHandlingResponseRestDto | null,
      mappedColumns: [] as MappedColumnRestDto[],
    }
  },
  mounted() {
    this.initialize();
  },
  computed: {
    DpModuleEnum() {
      return DpModuleEnum;
    },
    hideNextButton(): boolean {
      return this.selectedFileType === ''
          || (this.selectedFileType === 'csv' && !this.prepareCsvHandlingRequest.document_key)
          || (this.selectedFileType === 'xlsx' && !this.prepareXlsxHandlingRequest.document_key);
    }
  },
  methods: {
    async doInitialize(): Promise<void> {
      // Do nothing
    },
    async doReload(): Promise<void> {
      // Do nothing
    },
    async submitSelection(): Promise<void> {
      await this.performGenericSubmit(this.doSubmitSelection, this.doNothing);
    },
    async doSubmitSelection(): Promise<void> {
      if (this.selectedFileType === 'csv') {
        this.prepareImportHandlingResponse =
          await ImportRestService.getInstance().prepareCsvHandling(
            this.prepareCsvHandlingRequest,
            'IMPORT_PIM_PRODUCT_INFO'
          );
      } else {
        this.prepareImportHandlingResponse =
          await ImportRestService.getInstance().prepareXlsxHandling(
            this.prepareXlsxHandlingRequest,
            'IMPORT_PIM_PRODUCT_INFO'
          );
      }

      this.step = 'mapping';
      this.mappedColumns = [];
      for (let index: number = 0; index < this.prepareImportHandlingResponse!.headers.length; index++) {
        this.mappedColumns.push({
          column_index: index,
          column_type_code: 'UNDEFINED'
        });
      }
    },
    goBack(): void {
      this.step = 'selection';
    },
    async submitMapping(): Promise<void> {
      await this.performGenericSubmit(this.doSubmitMapping, this.doNothing);
    },
    async doSubmitMapping(): Promise<void> {
      const columns: MappedColumnRestDto[] = this.mappedColumns
        .filter((column: MappedColumnRestDto) => column.column_type_code !== 'UNDEFINED')
        .map((column: MappedColumnRestDto) => {
            return {
              column_index: column.column_index,
              column_type_code: column.column_type_code
            }
          }
        );

      if (this.selectedFileType === 'csv') {
        const request: HandleCsvRequestRestDto = {
          document_key: this.prepareCsvHandlingRequest.document_key,
          csv_metadata: this.prepareCsvHandlingRequest.csv_metadata,
          mapped_columns: columns
        };
        this.handlingResponse = await ImportRestService.getInstance().handleCsv(
          request,
          'IMPORT_PIM_PRODUCT_INFO'
        );
      } else {
        const request: HandleXlsxRequestRestDto = {
          document_key: this.prepareXlsxHandlingRequest.document_key,
          xlsx_metadata: this.prepareXlsxHandlingRequest.xlsx_metadata,
          mapped_columns: columns
        };
        this.handlingResponse = await ImportRestService.getInstance().handleXlsx(
          request,
          'IMPORT_PIM_PRODUCT_INFO'
        );
      }

      this.$router.push({
        name: 'async-handlings',
        params: {
          moduleCode: DpModuleEnum.CPC,
          pollingId: this.handlingResponse?.polling_id,
          backRoute: 'pim-products-overview'
        }
      });
    },
    mappedColumnUpdated(index: number): void {
      if (this.mappedColumns[index].column_type_code === null) {
        this.mappedColumns[index].column_type_code = 'UNDEFINED';
      }
    },
    setErrorMessage(error: any): void {
      if (error instanceof String) {
        this.pageUI.setError(error as string);
        return;
      }

      this.setExceptions(error);
    },
  }
})
